/*
 * @Author: 王丛
 * @Date: 2022-03-08 15:30:52
 * @LastEditors: zhuguoqin zhuguoqin@chunyu.me
 * @LastEditTime: 2023-05-17 16:57:25
 * @Description: file content
 */
// 工具函数
import * as cyDetect from '@cy/detect';
// eslint-disable-next-line import/no-extraneous-dependencies
import CollectReport from '@@/utils/report';
import cyShare from '@cy/share'; // 分享
import { wxMiniIntroPage } from '@/services/index';

const APP = cyDetect.isFromCYAll() ? '0' : 'weixin_mini'; // 打点工具函数使用，判断当前环境
export const getQueryStr = (key, str) => {
  const queryString = str.match(new RegExp(`[?&]${key}=([^&]*)`, 'i'));
  const val = (queryString && queryString.length > 1 && queryString[1]) || '';
  return decodeURIComponent(val);
};
/**
 * 打点
 *
 * @param {string} key 事件名
 * @param {object} segmentation 打点参数
 */
export const doPoint = (key, segmentation) => {
  const ReportData = new CollectReport({
    key,
    segmentation: { app: APP, ...segmentation },
    cyudId:
      window && window.location.href
        ? getQueryStr('cyudId', window.location.search)
        : '',
  });
  return new Promise(resolve => {
    ReportData.report().then(res => {
      resolve(res);
    });
  });
};
/**
 * 是否为ios
 */
export const isIos = () => {
  const u = navigator.userAgent;
  if (u.indexOf('iPhone') > -1 || u.indexOf('iOS') > -1) {
    return true;
  }
  return false;
};
/**
 * 是否10.0版本
 *
 * @returns {boolean} 是否10.0版本
 */
export const isVersion10 = () => {
  return cyDetect.isFromCY() && cyDetect.isGreaterAppVersion('10.0.0', true); // 是否沉浸式，默认为否
};

export const isVersion91 = () => {
  return cyDetect.isFromCY() && cyDetect.isGreaterAppVersion('9.1.0', true); // 是否沉浸式，默认为否
};

export const requestEvent = nextUrl => {
  let target = nextUrl;
  if (!target) {
    target = window.location.href;
  }
  if (cyDetect.isFromCY()) {
    // 客户端登录
    window.location.href = `${
      window.location.origin
    }/accounts/login/?next=${encodeURIComponent(target)}`;
  } else {
    // h5 登录
    window.location.href = `${
      window.location.origin
    }/cooperation/wap/quick_login/?next=${encodeURIComponent(target)}`;
  }
};
/**
 * @description: 获取跳转大搜的url-link并跳转
 * @param order_type
 * @param {*} query 搜索词
 * @returns {*}
 */
export const getUrlLink = (query = '', order_type = 'recall_search') => {
  try {
    wxMiniIntroPage({
      order_type,
      from_type: 'seo-m',
      is_json: '1',
      query,
    })
      .then(res => {
        const wxUrl = res.url_link || '';
        if (wxUrl) {
          window.location.href = wxUrl;
        }
      })
      .catch(e => {
        console.log(e);
      });
  } catch (e) {
    console.log(e);
  }
};
// 单个分享
export const singleShare = ({
  title,
  desc,
  img,
  link = window.location.href,
  platform,
  page_readable_name,
}) => {
  title = title ? title.substr(0, 50) : title;
  desc = desc ? desc.substr(0, 50) : desc;
  const opt = {
    title,
    link,
    mini_image: img || '',
    img: img || '',
    // btn_visible: false,
    direct_share_to: platform,
    desc: desc || ' ',
    userName: 'gh_681d3fd5683f', // 安卓
    mini_id: 'gh_681d3fd5683f', // IOS
    path: `/pages/h5_webview/index?url=${encodeURIComponent(
      window.location.href
    )}`,
    page_title: page_readable_name,
    share_title: title,
  };
  cyShare.app(opt);
};

// 分享
export const share = ({
  title,
  desc,
  img,
  link = window.location.href,
  page_readable_name,
  share_to = [],
  direct_share_to,
  img_base64,
}) => {
  title = title ? title.substr(0, 50) : title;
  desc = desc ? desc.substr(0, 50) : desc;
  const opt = {
    title,
    link,
    mini_image: img || '',
    img: img || '',
    desc: desc || ' ',
    need_invitate_id: false,
    userName: 'gh_681d3fd5683f', // 安卓
    mini_id: 'gh_681d3fd5683f', // IOS
    path: `/pages/h5_webview/index?url=${encodeURIComponent(
      window.location.href
    )}`,
    share_title: title,
    page_title: page_readable_name,
    direct_share_to,
    img_base64,
  };
  if (share_to.length) {
    opt.share_to = share_to;
  }
  cyShare.app(opt);
};

export default {
  doPoint,
  isVersion10,
  isVersion91,
  getQueryStr,
  requestEvent,
};
